import type { Role } from '../types/auth';

const ROLE_PERMISSIONS = {
  administrator: [
    'access_admin_dashboard',
    'manage_users',
    'generate_reports',
    'manage_content',
    'manage_jobs',
    'manage_projects',
    'manage_profile',
  ],
  recruiter: [
    'post_jobs',
    'manage_jobs',
    'request_quote',
    'manage_projects',
    'write_freelancer_reviews',
    'manage_profile',
    'view_messages',
    'send_messages',
    'accept_quote',
    'request_changes',
    'decline_quote',
    'create_jobs',
  ],
  freelancer: [
    'manage_profile',
    'submit_quotes',
    'manage_alliances',
    'request_alliance',
    'write_recruiter_reviews',
    'view_messages',
    'send_messages',
  ],
} as const;

export type Permission = (typeof ROLE_PERMISSIONS)[keyof typeof ROLE_PERMISSIONS][number];

export function getPermissionsForRole(role: Role | null): Permission[] {
  if (!role) return [];
  return Array.from(ROLE_PERMISSIONS[role] || []);
}

export { ROLE_PERMISSIONS };
